import axios from "axios";
import endpoint from "../../index.routes";

const addBatch = async (params) => {
  const response = await axios.post(endpoint.BATCH, params, {
    headers: { token: localStorage.getItem("hp_token") },
  });
  return response.data;
};

const getBatches = async (params) => {
  const { limit, offset, searchText } = params;
  const response = await axios.get(
    endpoint.BATCH,
    {
      params: searchText ? { limit, offset, searchText } : { limit, offset },
      headers: { token: localStorage.getItem("hp_token") },
    }
  );
  return response.data;
};

const getBatchById = async (params) => {
  const { id } = params;
  const response = await axios.get(
    endpoint.BATCH + "/" + id,
    {
      headers: { token: localStorage.getItem("hp_token") },
    }
  );
  return response.data;
};

const updateBatchData = async (params) => {
  const response = await axios.put(endpoint.BATCH + "/" + params.id,
    params?.body, {
    headers: { token: localStorage.getItem("hp_token") }, 
  });
  return response.data;
}

const deleteBatchById = async (params) => {
  const response = await axios.delete(`${endpoint.BATCH}/${params}`,
    {
      headers: { token: localStorage.getItem("hp_token")},
    }
  );
  return response.data;
}

const batchServices = {
  addBatch,
  getBatches,
  getBatchById,
  updateBatchData,
  deleteBatchById
};

export default batchServices;